import * as React from "react";
import styled, { css } from "styled-components";

import { color } from "@8x8/oxygen-constants";
import { CloseCircleIcon, CheckIcon } from "@8x8/oxygen-icon";
import { Spinner } from "@8x8/oxygen-loaders";
import { COLORS } from "@/react/theme/constants";

const Flex = styled.div`
  display: flex;
`;

const Span = styled.span`
  margin-right: 4px;
`;

const StyledSpinner = styled(Spinner)`
  margin-right: 4px;
`;

const GreenText = styled.strong`
  color: ${COLORS.success};
`;

const GreyText = styled.strong`
  color: ${COLORS.secondary};
`;

const icon = css`
  margin-right: 4px;
`;

const ActiveIcon = styled(CheckIcon)`
  ${icon};
  fill: ${color.jadeGreen};
`;

const GreyCrossIcon = styled(CloseCircleIcon)`
  ${icon};
  fill: ${COLORS.secondary};
`;

const StatusIndicator = ({ value, isLoading }) => {
  return (
    <Flex>
      <Span>
        <strong>STATUS:</strong>
      </Span>
      <Flex>
        {value === true && !isLoading && (
          <>
            <ActiveIcon />
            <GreenText>ACTIVE</GreenText>
          </>
        )}
        {value !== true && !isLoading && (
          <>
            <GreyCrossIcon />
            <GreyText>INACTIVE</GreyText>
          </>
        )}
        {isLoading && (
          <>
            <StyledSpinner size={20} />
            <GreyText>Pending</GreyText>
          </>
        )}
      </Flex>
    </Flex>
  );
};

export default StatusIndicator;
